<template>
  <div
    class="el-form-item"
    :class="[{
               'el-form-item--feedback': elForm && elForm.statusIcon,
               'is-error': validateState === 'error',
               'is-validating': validateState === 'validating',
               'is-success': validateState === 'success',
               'is-required': isRequired || required,
               'is-no-asterisk': elForm && elForm.hideRequiredAsterisk
             },
             sizeClass ? 'el-form-item--' + sizeClass : ''
    ]"
  >
    <label-wrap
      :is-auto-width="labelStyle && labelStyle.width === 'auto'"
      :update-all="form.labelWidth === 'auto'"
    >
      <label
        :for="labelFor"
        class="el-form-item__label"
        :style="labelStyle"
        v-if="label || $slots.label"
      >
        <slot name="label">{{ label + form.labelSuffix }}</slot>
      </label>
    </label-wrap>
    <div
      class="el-form-item__content"
      :style="contentStyle"
    >
      <slot />

      <template v-if="withoutTextAnimation">
        <slot
          v-if="validateState === 'error' && showMessage && form.showMessage"
          name="error"
          :error="validateMessage"
        >
          <div
            class="el-form-item__error"
            :class="{
              'el-form-item__error--inline': typeof inlineMessage === 'boolean'
                ? inlineMessage
                : (elForm && elForm.inlineMessage || false)
            }"
          >
            {{ validateMessage }}
          </div>
        </slot>
      </template>

      <transition
        name="el-zoom-in-top"
        v-else
      >
        <slot
          v-if="validateState === 'error' && showMessage && form.showMessage"
          name="error"
          :error="validateMessage"
        >
          <div
            class="el-form-item__error"
            :class="{
              'el-form-item__error--inline': typeof inlineMessage === 'boolean'
                ? inlineMessage
                : (elForm && elForm.inlineMessage || false)
            }"
          >
            {{ validateMessage }}
          </div>
        </slot>
      </transition>
    </div>
  </div>
</template>

<script>
import { FormItem } from 'element-ui';

export default {
  extends: FormItem,
  props: {
    withoutTextAnimation: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitBlur() {
      this.$emit('input:blur');
    },
    emitFocus() {
      this.$emit('input:focus');
    },
  },
  mounted() {
    this.$on('el.form.input.blur', this.emitBlur);
    this.$on('el.form.input.focus', this.emitFocus);
  },
};
</script>
